import React from "react";
import LearnMore from "../../../../../../LearnMore/LearnMore";
import DMSContainer from "./DMSContainer";
import '../../styles/SelectDMSAccounts.scss';

export const SelectDMSAccounts = (props) => {
  const {apiDetails, subscriptionData } = props;
  return (
    <div className="dms-outer-box">
        <span>Select the DMS accounts to use with this app. </span> 
        <LearnMore 
        docPath="/docs/marketplace/marketplace-for-apps/managing-app-configurations/#managing-dms-accounts"
        screen="DMS Accounts"/>
        <div className="dms-container-box">
            <DMSContainer apiDetails={apiDetails} subscriptionData={subscriptionData}/>
        </div>
    </div>
  )
}
